import { useState, useEffect, useCallback } from 'react';
import useWebSocket, { ReadyState } from 'react-use-websocket';

const usePaymentWebSocket = (userId, enabled = true) => {
    const [paymentEvent, setPaymentEvent] = useState(null);

    // Calculate WebSocket URL dynamically based on SERVER_URL
    // let apiDomain = (typeof process !== 'undefined' && process.env && process.env.REACT_APP_SERVER_URL) ? process.env.REACT_APP_SERVER_URL : 'http://localhost:3000';
    let apiDomain = process.env.REACT_APP_SERVER_URL || 'http://localhost:3000';
    if (apiDomain.endsWith('/')) {
        apiDomain = apiDomain.slice(0, -1);
    }
    // Automatically switch: http:// -> ws:// and https:// -> wss://
    const WS_URL = apiDomain.replace(/^http(s?):\/\//, 'ws$1://') + '/ws/payment';

    // Append userId as a query parameter for subscription
    const socketUrl = userId && enabled ? `${WS_URL}?userId=${userId}` : null;

    const { lastMessage, readyState, sendMessage } = useWebSocket(socketUrl, {
        shouldReconnect: (closeEvent) => true,
        reconnectAttempts: 10,
        reconnectInterval: 3000,
        onOpen: () => console.log(`WebSocket connected for userId: ${userId}`),
        onClose: () => console.log(`WebSocket disconnected for userId: ${userId}`),
        onError: (event) => console.error('WebSocket error:', event),
    });

    useEffect(() => {
        if (readyState === ReadyState.OPEN && userId) {
            console.log(`Performing SUBSCRIBE handshake for userId: ${userId} ,${socketUrl},${readyState}, ${lastMessage}`);
            console.log(lastMessage)
            sendMessage(JSON.stringify({ type: 'SUBSCRIBE', transactionId: userId }));
        }
    }, [readyState, userId, sendMessage]);

    useEffect(() => {
        if (lastMessage !== null) {
            try {
                const data = JSON.parse(lastMessage.data);
                console.log('Received payment event:', data);
                if (data.type === 'PAYMENT_UPDATE') {
                    setPaymentEvent(data);
                }
            } catch (error) {
                console.error('Error parsing WebSocket message:', error);
            }
        }
    }, [lastMessage]);

    const clearEvent = useCallback(() => {
        setPaymentEvent(null);
    }, []);

    const connectionStatus = {
        [ReadyState.CONNECTING]: 'Connecting',
        [ReadyState.OPEN]: 'Open',
        [ReadyState.CLOSING]: 'Closing',
        [ReadyState.CLOSED]: 'Closed',
        [ReadyState.UNINSTANTIATED]: 'Uninstantiated',
    }[readyState];

    return {
        paymentEvent,
        isConnected: readyState === ReadyState.OPEN,
        connectionStatus,
        clearEvent,
        sendMessage, // Exposed just in case we need to ping/pong manually
    };
};

export default usePaymentWebSocket;
